import { Grid } from 'components/grid'
import ProgressBar from 'components/progress-bar'
import type { TStyleVariant } from '@/types/style/variant'
import type { FunctionalComponent, MaybeRef } from 'vue'
import { computed, defineComponent, unref, type Ref } from 'vue'
import type { JSX } from 'vue/jsx-runtime'
import { useResponsive } from '~/composables/useResponsive'


export const DuplexLoader = defineComponent<{
  progress: Ref<number>
  text?: MaybeRef<string>
  left: FunctionalComponent<any>
  right: FunctionalComponent<any>
  classLeft?: MaybeRef<string>
  classRight?: MaybeRef<string>
  progressVariant?: TStyleVariant
  body?: FunctionalComponent<any> | MaybeRef<JSX.Element>
}>(
  (props) => {
    const responsive = useResponsive();
    const classLeft = computed(
      () => unref(props.classLeft) || 'bg-findex-900 flex items-center justify-center'
    )
    const classRight = computed(
      () =>
        unref(props.classRight) ||
        'bg-gray-100 border border-gray-300 flex items-center justify-center'
    )

    const body = computed(() => {
      if (props.text && unref(props.text)) {
        return unref(props.text)
      }
      if (typeof props.body === 'function') {
        return <props.body />
      }
      return unref(props.body)
    })

    return () => {
      return (
        <div class="min-w-[324px] md:min-w-[424px] flex flex-col justify-center">
          <div class="h-auto flex justify-center flex-col items-center gap-12">
            <div class="w-[324px] md:w-[424px] h-auto flex justify-center items-center">
              <Grid noDefaultLayout columns={responsive.isSmall.value ? "64px auto 64px" : "86px auto 86px"} alignItems="center" class="w-full max-w-full">
                <div class={classLeft.value}>{<props.left />}</div>
                <div class="px-8">
                  <ProgressBar
                    variant={props.progressVariant}
                    withBackground
                    size="s"
                    square
                    value={props.progress}
                    scale100
                  />
                </div>
                <div class={classRight.value}>{<props.right />}</div>
              </Grid>
            </div>
            <div class="flex items-center justify-center">
              <div class="text-[#111928] text-base font-semibold font-['Inter'] leading-normal">
                {body.value}
              </div>
            </div>
          </div>
        </div>
      )
    }
  },
  {
    props: [
      'progress',
      'progressVariant',
      'text',
      'left',
      'right',
      'classLeft',
      'classRight',
      'body'
    ]
  }
)
